export const splitStringIntoTwoWords = (input?: string): string => {
  if (!input) {
    return '';
  }

  return input.replace(/(?<!^)([A-Z])/g, ' $1');
};
